import Joi from 'joi';

const CommentaryValidator = {
  schema: Joi.object({
    commentary: Joi.string().trim().min(25).max(1000)
  })
};

export default CommentaryValidator;
